<template>
    <div v-if="settings">
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Api Key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.apiKey" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Api Url</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.apiUrl" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="saveAsync();" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import komplexbridgeService from "../../../../services/komplexbridge.service";

    export default {
        name: "client-settings-komplexbridge",
        data: () => ({ settings: null }),
        computed: {
            clientId: function() {
                return Number(this.$route.params.clientId);
            }
        },
        async mounted() {
            this.loadSettingsAsync();
        },
        methods: {
            async loadSettingsAsync() {
                this.settings = await komplexbridgeService.getSettingsByClientAsync(this.clientId);
            },
            async saveAsync() {
                await komplexbridgeService.saveAsync(this.clientId, this.settings);
            }
        }
    };
</script>

<style lang="scss">
    .game-id {
        margin-bottom: 0.32rem;
        padding: 0.4rem 0.8rem;
        max-width: 800px;
        border: 1px solid #666;
        border-radius: 0.2rem;
        background-color: #333;
        .icon

    {
        margin-right: 0.2rem;
    }

    div {
        width: 100%;
    }

    input {
        width: 352px;
    }
    }
</style>


// WEBPACK FOOTER //
// front/src/components/clients/client/settings/komplexbridge.vue